import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";


import Vant from 'vant';
import 'vant/lib/index.css';
import wxapi from './assets/js/wxapi';
import * as echarts from 'echarts';

Vue.use(Vant);

Vue.use(wxapi);

Vue.config.ignoredElements = [
  'wx-open-launch-weapp',
]

Vue.prototype.$echarts = echarts;
Vue.config.productionTip = false;

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");
